export const hasCompletedOnboarding = (user: any) => {
  if (!user || !user.firstName || !user.lastName || !user.username) {
    return false
  }

  return true
}

export const types = {
  TRAINER: 'trainer',
  CLIENT: 'client',
}
